// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { Modal, Button, Container, ListGroup, Col, Row, Alert } from 'react-bootstrap';
import ModalForm from '../../Modal/Modal';
import ModalAsingProductCupon from './ModalAsingProductCupon';
import ModalAsingCombosCupon from './ModalAsingCombosCupon';
import ModalAsingCategoriesCupon from './ModalAsingCategoriesCupon';
import ModalAsingBranchOfficeCupon from './ModalAsingBranchOfficeCupon';
import defaultImage from "../../../assets/img/default.png";
import { CouponPosFetchAPI } from '../../../api/Coupon';
import { RenderIf } from '../../utils/RenderIf';
import AlertError from '../../Alerts/ErrorAlert';
import Swal from 'sweetalert2';
import ModalAsingDayCupon from './ModalAsingDayCupon';
import ModalAsingHoursCupon from './ModalAsingHoursCupon';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import './cupon.css';

/* ── ICONS ── */
const IcoTag   = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>;
const IcoX     = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoPlus  = ()=><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoTrash = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6M14 11v6M9 6V4h6v2"/></svg>;

/* day label helper */
const dayLabel = v => ({ MON:'Lunes', TUE:'Martes', WED:'Miércoles', THU:'Jueves', FRI:'Viernes', SAT:'Sábado', SUN:'Domingo' }[v] || v);

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const ModalDetailCupons = ({ cupon, groups, combos, categories, showModal, setShowModal, user }) => {



  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [detailCupon, setDetailCupon] = useState({
    generated_cupons: 0, visible_ecommerce: 0, days: [], maxDiscount: 0, minAmount: 0,
    expirationDate: "No definido", hours: [], img: "", name: "", description: "",
    discount_value: 0, discount_type: "FIXED", type: "PRODUCT",
    conditions: [], categories: [], combos: [], groups: [], usage: [], branchoffice: []
  });
  const [eventHandler, setEventHandler]                       = useState(0);
  const [showProductModal, setShowProductModal]               = useState(false);
  const [showComboModal, setShowComboModal]                   = useState(false);
  const [showCategorieModal, setShowCategorieModal]           = useState(false);
  const [showBranchOfficeModal, setShowBranchOfficeModal]     = useState(false);
  const [showDayModal, setShowDayModal]                       = useState(false);
  const [showHourModal, setShowHourModal]                     = useState(false);

  const getDetailCupon = async (cupon) => {
    try {
      const response = await CouponPosFetchAPI.getCupon(cupon, localStorage.getItem('x-access-token'));
      let days           = response.data.data.conditions.filter(c => c.condition_type === "DAY");
      let hours          = response.data.data.conditions.filter(c => c.condition_type === "TIME");
      let maxDiscount    = response.data.data.conditions.filter(c => c.condition_type === "max_discount");
      let minAmount      = response.data.data.conditions.filter(c => c.condition_type === "min_order_value");
      let expirationDate = response.data.data.conditions.filter(c => c.condition_type === "expiration_date");
      console.log(response.data.data);
      setDetailCupon({
        ...response.data.data, days, hours,
        maxDiscount: maxDiscount && maxDiscount.length > 0 ? maxDiscount[0].condition_value : "No definido",
        minAmount: minAmount && minAmount.length > 0 ? minAmount[0].condition_value : "No definido",
        expirationDate: expirationDate && expirationDate.length > 0 ? expirationDate[0].condition_value : "No definido"
      });
    } catch (err) {}
  };

  const removeProductFromCupon = async (product) => {
    try {
      Swal.fire({ title:'¿Estas seguro?', text:"No podras revertir esto!", icon:'warning', showCancelButton:true, confirmButtonColor:'#3085d6', cancelButtonColor:'#d33', confirmButtonText:'Si, eliminar!', cancelButtonText:'Cancelar' })
        .then(async result => {
          if (result.isConfirmed) {
            try {
              await CouponPosFetchAPI.removeProductFromCupon(cupon, product, localStorage.getItem('x-access-token'));
              AlertError('Producto removido correctamente','Exito','success'); setEventHandler(1);
            } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar el producto del cupon','error','error'); }
          }
        });
    } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar el producto del cupon','error','error'); }
  };

  const removeComboFromCupon = async (combo) => {
    try {
      Swal.fire({ title:'¿Estas seguro?', text:"No podras revertir esto!", icon:'warning', showCancelButton:true, confirmButtonColor:'#3085d6', cancelButtonColor:'#d33', confirmButtonText:'Si, eliminar!', cancelButtonText:'Cancelar' })
        .then(async result => {
          if (result.isConfirmed) {
            try {
              await CouponPosFetchAPI.removeComboFromCupon(cupon, combo, localStorage.getItem('x-access-token'));
              AlertError('Combo removido correctamente','Exito','success'); setEventHandler(1);
            } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar el combo del cupon','error','error'); }
          }
        });
    } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar el combo del cupon','error','error'); }
  };

  const removeCategoryFromCupon = async (category) => {
    try {
      Swal.fire({ title:'¿Estas seguro?', text:"No podras revertir esto!", icon:'warning', showCancelButton:true, confirmButtonColor:'#3085d6', cancelButtonColor:'#d33', confirmButtonText:'Si, eliminar!', cancelButtonText:'Cancelar' })
        .then(async result => {
          if (result.isConfirmed) {
            try {
              await CouponPosFetchAPI.removeCategorieFromCupon(cupon, category, localStorage.getItem('x-access-token'));
              AlertError('Categoria removida correctamente','Exito','success'); setEventHandler(1);
            } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar la categoria del cupon','error','error'); }
          }
        });
    } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar la categoria del cupon','error','error'); }
  };

  const removeBranchOfficeFromCupon = async (branch) => {
    try {
      Swal.fire({ title:'¿Estas seguro?', text:"No podras revertir esto!", icon:'warning', showCancelButton:true, confirmButtonColor:'#3085d6', cancelButtonColor:'#d33', confirmButtonText:'Si, eliminar!', cancelButtonText:'Cancelar' })
        .then(async result => {
          if (result.isConfirmed) {
            try {
              await CouponPosFetchAPI.removeBranchOfficeFromCupon(cupon, branch, localStorage.getItem('x-access-token'));
              AlertError('Sucursal removida correctamente','Exito','success'); setEventHandler(1);
            } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar la sucursal del cupon','error','error'); }
          }
        });
    } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar la sucursal del cupon','error','error'); }
  };

  const removeConditionFromCupon = async (condition) => {
    try {
      Swal.fire({ title:'¿Estas seguro?', text:"No podras revertir esto!", icon:'warning', showCancelButton:true, confirmButtonColor:'#3085d6', cancelButtonColor:'#d33', confirmButtonText:'Si, eliminar!', cancelButtonText:'Cancelar' })
        .then(async result => {
          if (result.isConfirmed) {
            try {
              await CouponPosFetchAPI.removeConditionCupon(cupon, condition, localStorage.getItem('x-access-token'));
              AlertError('Condicion removida correctamente','Exito','success'); setEventHandler(1);
            } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar la condicion del cupon','error','error'); }
          }
        });
    } catch (err) { AlertError(err.response.data.error !== undefined ? err.response.data.error : 'Error al eliminar la condicion del cupon','error','error'); }
  };

  useEffect(() => { if (showModal) getDetailCupon(cupon); }, [showModal]);
  useEffect(() => { if (eventHandler === 1) { getDetailCupon(cupon); setEventHandler(0); } }, [eventHandler]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  /* ── render helper: list section ── */
  const ItemList = ({ items, nameKey, idKey, onRemove, emptyText }) => (
    <div className="mdc-items">
      {items.length > 0 ? items.map((item, i) => (
        <div className="mdc-item" key={i}>
          <span className="mdc-item-name">{item[nameKey]}</span>
          <button className="mdc-btn-remove" onClick={e => onRemove(item[idKey])}>
            <IcoTrash />
          </button>
        </div>
      )) : <span className="mdc-empty-list">{emptyText || 'Sin elementos'}</span>}
    </div>
  );

  return (
    <div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        dialogClassName="mdc-dialog"
      >
        <Modal.Header className="text-center">
          <h3><i className="uil uil-eye" /> Detalle del cupon</h3>
        </Modal.Header>

        <Modal.Body>

          {/* ── visual header ── */}
          <div className="mdc-head">
            <div className="mdc-head-ico"><IcoTag /></div>
            <div className="mdc-head-info">
              <div className="mdc-head-title">{detailCupon.name || 'Detalle del cupón'}</div>
              <div className="mdc-head-sub">
                {detailCupon.discount_type === "FIXED" ? "Descuento fijo" : detailCupon.discount_type === "PERCENTAGE" ? "Descuento porcentaje" : "Producto gratis"}
                {detailCupon.name && <> · {detailCupon.discount_type === "FIXED" ? "$" : ""}{detailCupon.discount_value?.toFixed(2)}{detailCupon.discount_type === "PERCENTAGE" ? "%" : ""}</>}
              </div>
            </div>
            <button className="mdc-close" type="button" onClick={() => setShowModal(false)}><IcoX /></button>
          </div>

          {/* ── imagen — lógica original intacta ── */}
          <div className="mdc-img-wrap">
            <img
              className="mdc-img imgEditModal"
              loading="lazy"
              src={detailCupon.img ? buildCloudinaryImageUrl({ url: detailCupon.img, width: 600, quality: "auto", type: "image" }) : defaultImage}
              alt=""
            />
          </div>

          {/* ── body ── */}
          <div className="mdc-body">
            <div className="mdc-grid">

              {/* ══ COLUMNA IZQUIERDA ══ */}
              <div>

                {/* info general */}
                <div className="mdc-section">
                  <div className="mdc-section-head"><span className="mdc-section-label">Información general</span></div>
                  <div className="mdc-section-body">
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Nombre</div><div className="mdc-info-val">{detailCupon.name}</div></div>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Tipo de descuento</div><div className="mdc-info-val">{detailCupon.discount_type === "FIXED" ? "Fijo" : detailCupon.discount_type === "PERCENTAGE" ? "Porcentaje" : "Producto gratis"}</div></div>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Cantidad aplicable</div><div className="mdc-info-val">{detailCupon.discount_type === "FIXED" ? "$" : ""}{detailCupon.discount_value?.toFixed(2)}{detailCupon.discount_type === "PERCENTAGE" ? "%" : ""}</div></div>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Aplica a</div><div className="mdc-info-val">{detailCupon.type === "PRODUCT" ? "Productos" : "Orden completa"}</div></div>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">¿Limitado?</div><div className="mdc-info-val">{detailCupon.is_general === 1 ? <span className="mdc-badge-off">No</span> : <span className="mdc-badge-on">Sí</span>}</div></div>
                    <RenderIf isTrue={detailCupon.is_general === 0}>
                      <div className="mdc-info-row"><div className="mdc-info-lbl">Cupones disponibles</div><div className="mdc-info-val">{detailCupon.code_count}</div></div>
                      <div className="mdc-info-row"><div className="mdc-info-lbl">Cupones generados</div><div className="mdc-info-val">{detailCupon.generated_cupons}</div></div>
                    </RenderIf>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Monto mínimo</div><div className="mdc-info-val">${detailCupon.minAmount}</div></div>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Descuento máximo</div><div className="mdc-info-val">${detailCupon.maxDiscount}</div></div>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Fecha expiración</div><div className="mdc-info-val">{detailCupon.expirationDate}</div></div>
                    <div className="mdc-info-row"><div className="mdc-info-lbl">Descripción</div><div className="mdc-info-val">{detailCupon.description}</div></div>
                    <div className="mdc-info-row" style={{ borderBottom:'none' }}><div className="mdc-info-lbl">Visible en ecommerce</div><div className="mdc-info-val">{detailCupon.visible_ecommerce === 1 ? <span className="mdc-badge-on">Sí</span> : <span className="mdc-badge-off">No</span>}</div></div>
                  </div>
                </div>

                {/* productos y combos — RenderIf original intacto */}
                <RenderIf isTrue={detailCupon.type === "PRODUCT"}>
                  {/* productos */}
                  <div className="mdc-section">
                    <div className="mdc-section-head">
                      <span className="mdc-section-label">Productos</span>
                      <button className="mdc-btn-add btn btn-primary btn-sm border-0 m-2" onClick={e => setShowProductModal(true)}>
                        <IcoPlus /> Agregar
                      </button>
                    </div>
                    <div className="mdc-section-body">
                      <ItemList items={detailCupon.groups} nameKey="name" idKey="group_id" onRemove={removeProductFromCupon} emptyText="Sin productos asignados" />
                    </div>
                  </div>
                  {/* combos */}
                  <div className="mdc-section">
                    <div className="mdc-section-head">
                      <span className="mdc-section-label">Combos</span>
                      <button className="mdc-btn-add btn btn-primary btn-sm border-0 m-2" onClick={e => setShowComboModal(true)}>
                        <IcoPlus /> Agregar
                      </button>
                    </div>
                    <div className="mdc-section-body">
                      <ItemList items={detailCupon.combos} nameKey="name" idKey="combo_id" onRemove={removeComboFromCupon} emptyText="Sin combos asignados" />
                    </div>
                  </div>
                </RenderIf>

              </div>

              {/* ══ COLUMNA DERECHA ══ */}
              <div>

                {/* categorías */}
                <div className="mdc-section">
                  <div className="mdc-section-head">
                    <span className="mdc-section-label">Categorías</span>
                    <button className="mdc-btn-add btn btn-primary btn-sm border-0 m-2" onClick={e => setShowCategorieModal(true)}>
                      <IcoPlus /> Agregar
                    </button>
                  </div>
                  <div className="mdc-section-body">
                    <ItemList items={detailCupon.categories} nameKey="name" idKey="category_id" onRemove={removeCategoryFromCupon} emptyText="Sin categorías asignadas" />
                  </div>
                </div>

                {/* sucursales */}
                <div className="mdc-section">
                  <div className="mdc-section-head">
                    <span className="mdc-section-label">Sucursales</span>
                    <button className="mdc-btn-add btn btn-primary btn-sm border-0 m-2" onClick={e => setShowBranchOfficeModal(true)}>
                      <IcoPlus /> Agregar
                    </button>
                  </div>
                  <div className="mdc-section-body">
                    <ItemList items={detailCupon.branchoffice} nameKey="name" idKey="branchoffice_id" onRemove={removeBranchOfficeFromCupon} emptyText="Sin sucursales asignadas" />
                  </div>
                </div>

                {/* días */}
                <div className="mdc-section">
                  <div className="mdc-section-head">
                    <span className="mdc-section-label">Días de la semana</span>
                    <button className="mdc-btn-add btn btn-primary btn-sm border-0 m-2" onClick={e => setShowDayModal(true)}>
                      <IcoPlus /> Agregar
                    </button>
                  </div>
                  <div className="mdc-section-body">
                    <div className="mdc-items">
                      {detailCupon.days.length > 0 ? detailCupon.days.map((day, index) => (
                        <div className="mdc-item" key={index}>
                          <span className="mdc-item-name">
                            {/* lógica original de mapeo de días intacta */}
                            {day.condition_value === "MON" ? "Lunes" : day.condition_value === "TUE" ? "Martes" : day.condition_value === "WED" ? "Miercoles" : day.condition_value === "THU" ? "Jueves" : day.condition_value === "FRI" ? "Viernes" : day.condition_value === "SAT" ? "Sabado" : "Domingo"}
                          </span>
                          <button className="mdc-btn-remove" onClick={e => removeConditionFromCupon(day.id)}><IcoTrash /></button>
                        </div>
                      )) : <span className="mdc-empty-list">Sin días asignados</span>}
                    </div>
                  </div>
                </div>

                {/* horas */}
                <div className="mdc-section">
                  <div className="mdc-section-head">
                    <span className="mdc-section-label">Horas del día</span>
                    <button className="mdc-btn-add btn btn-primary btn-sm border-0 m-2" onClick={e => setShowHourModal(true)}>
                      <IcoPlus /> Agregar
                    </button>
                  </div>
                  <div className="mdc-section-body">
                    <div className="mdc-items">
                      {detailCupon.hours.length > 0 ? detailCupon.hours.map((hour, index) => (
                        <div className="mdc-item" key={index}>
                          <span className="mdc-item-name">{hour.condition_value}</span>
                          <button className="mdc-btn-remove" onClick={e => removeConditionFromCupon(hour.id)}><IcoTrash /></button>
                        </div>
                      )) : <span className="mdc-empty-list">Sin horas asignadas</span>}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* footer */}
          <div className="mdc-footer">
            <button className="mdc-btn-close" type="button" onClick={() => setShowModal(false)}>Cerrar</button>
          </div>

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      {/* ── Sub-modales — props exactos originales ── */}
      <ModalAsingProductCupon showModal={showProductModal} setShowModal={setShowProductModal} groups={groups} setEventHandler={setEventHandler} selectedCupon={cupon} />
      <ModalAsingCombosCupon showModal={showComboModal} setShowModal={setShowComboModal} combos={combos} setEventHandler={setEventHandler} selectedCupon={cupon} />
      <ModalAsingCategoriesCupon showModal={showCategorieModal} setShowModal={setShowCategorieModal} categories={categories} selectedCupon={cupon} setEventHandler={setEventHandler} />
      <ModalAsingBranchOfficeCupon showModal={showBranchOfficeModal} setShowModal={setShowBranchOfficeModal} selectedCupon={cupon} user={user} setEventHandler={setEventHandler} />
      <ModalAsingDayCupon showModal={showDayModal} setShowModal={setShowDayModal} selectedCupon={cupon} setEventHandler={setEventHandler} />
      <ModalAsingHoursCupon showModal={showHourModal} setShowModal={setShowHourModal} selectedCupon={cupon} setEventHandler={setEventHandler} />

      {/* imports no usados como JSX — preservados */}
      {void [AlertError, Alert, ModalForm, Container, Row, Col, ListGroup]}
    </div>
  );
};

export default ModalDetailCupons;